/**
 * /admin/master-lodgements — Master lodgements kanban (route shell).
 * Screen impl in `./master-lodgements-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/master-lodgements')({
  component: lazyRouteComponent(
    () => import('./master-lodgements-screen'),
    'LodgementsBoard',
  ),
});
